'use client';

import cx from 'classnames';
import { useAtomValue } from 'jotai';

import ChevronRightIcon from '@flipster/ui/assets/svgs/chevron-right.svg';

import { glossaryTermAtom } from '../jotai';
import styles from './index.module.scss';

const Breadcrumb = ({ className }: { className?: string }) => {
  const glossaryTerm = useAtomValue(glossaryTermAtom);
  if (!glossaryTerm) return;

  return (
    <nav aria-label='Breadcrumb' className={cx(styles.nav, className)}>
      <ul>
        <li>
          <a href='/'>Home</a>
        </li>
        <li>
          <ChevronRightIcon />
        </li>
        <li>
          <a href='/glossary'>Glossary</a>
        </li>
        <li>
          <ChevronRightIcon />
        </li>
        <li>{glossaryTerm.name}</li>
      </ul>
    </nav>
  );
};

export default Breadcrumb;
